<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn w-160">
      <el-input
        clearable
        placeholder="请选择工作单位"
        v-model="deptName"
        @focus="showDeptModal"
        @clear="clearDepts">
      </el-input>
    </el-form-item>
    <el-form-item class="select_btn w-160 m-l-14">
      <el-select
        class="select_btn_style"
        v-model="filters.bindStatus"
        placeholder="浙政钉绑定状态"
      >
        <el-option
          v-for="(item, i) in bindStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn m-l-14">
      <el-select
        class="select_btn_style"
        v-model="filters.fromType"
        placeholder="添加方式"
      >
        <el-option
          v-for="(item, i) in addTypeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn w-160 m-l-14">
      <el-select
        class="select_btn_style"
        v-model="filters.pushStatus"
        placeholder="干部之家同步状态"
      >
        <el-option
          v-for="(item, i) in classPushStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn w-160 m-l-14">
      <el-select
        class="select_btn_style"
        v-model="filters.isGetCredit"
        placeholder="是否获得直播学分"
      >
        <el-option
          v-for="(item, i) in publicData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="姓名/手机号"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
    <SingleCheckTree ref="lazyTree" :defaultCheckedKeys="defaultCheckedKeys" :showModal="deptDialog" @deptSelected="selectDept" showTooltip/>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import SingleCheckTree from "./singleCheckTree";
import butn from "@/components/button/index";
export default {
  components: {
    butn,
    SingleCheckTree
  },
  data() {
    return {
      deptDialog: {
        flag: false
      },
      filters: {
        deptLevelCodeQuery: "",
      },
      publicData: [],
      deptName: "",
      defaultCheckedKeys: [],
      classPushStatusList: [],
      addTypeList: [],
      bindStatusData: [],
    };
  },
  props: {
  },
  created() {
    this.getSysParamByTypes(["IS_VALID", "CLASS_PUSH_STATUS", "LIVE_ROOM_USER_FROM_TYPE", "USER_BIND_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["IS_VALID"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["CLASS_PUSH_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["LIVE_ROOM_USER_FROM_TYPE"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["USER_BIND_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.publicData = res.data["IS_VALID"];
        this.classPushStatusList = res.data["CLASS_PUSH_STATUS"];
        this.addTypeList = res.data["LIVE_ROOM_USER_FROM_TYPE"];
        this.bindStatusData = res.data["USER_BIND_STATUS"];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.deptName = "";
      this.clearDepts();
      this.$emit("search", { t: new Date().getTime() });
    },
    // 选择工作单位弹窗
    showDeptModal() {
      this.deptDialog.flag = true;
    },
    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodeQuery = "";
      this.$nextTick(()=> {
        this.$refs.lazyTree.$refs["deptTree"].setCheckedKeys(this.defaultCheckedKeys);
      })
    },
    // 工作单位选择确定
    selectDept(dept) {
      this.deptName = dept.deptName;
      this.filters.deptLevelCodeQuery = dept.deptLevelCode;
      this.defaultCheckedKeys = [dept.uuid];
      this.deptDialog.flag = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.w-160 {
  width: 160px;
}
</style>
